export const TIME_OUT = 30000
export const BASE_URL: string | undefined = process.env.REACT_APP_BASE_URL
